exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".cookie[data-v-40ebdc76]{overflow-y:auto}.clickable[data-v-40ebdc76]{cursor:pointer}.actor-container[data-v-40ebdc76]{border-radius:5px;box-shadow:0 1px 4px rgba(0,0,0,.16)}.collapsed[data-v-40ebdc76]{height:0;opacity:0;transition:all .5s cubic-bezier(0,1,0,1)}.visible[data-v-40ebdc76]{opacity:1;height:100%}.file-container[data-v-40ebdc76]{background:#ffff!important;transition:background .2s ease}.file-container[data-v-40ebdc76]:hover{background:#f5f5f5!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-40ebdc76","scoped":true,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/dialog/types/DialogAggregateNotification.vue
// module id = 1079
// module chunks = 22